import React from "react";
import MenuItems from "./Menu/MenuItems";
import DriverCommercial from "./DriverComercial";
import BusinessCommercial from "./BusinessCommercial";
import PassengerCommercial from "./PassengerCommercial";

function Dashboard() {
    return (
        <div className="dashboard">
            <div className="menuItems--mobile">
                <MenuItems onCloseMenu={() => {}} />
            </div>

            <div className={"dashboard--blocks"}>
                <PassengerCommercial />
                <BusinessCommercial />
                <DriverCommercial />
            </div>
        </div>
    );
}

export default Dashboard;